import { initSplitApi } from './init'
import * as q from './elastic-query'


export const subscriptionAPI = initSplitApi.injectEndpoints({
    reducerPath: 'subscription',
    endpoints: (builder) => ({
        createSubscription: builder.mutation({
            query: (body) => {
                return {
                    url: `payment/subscription/create`,
                    method: 'POST',
                    service: 'subscription',
                    body
                };
            },
            providesTags: ['subscriptionCreate']
        }),
        createSession: builder.query({
            query: (body) => {
                return {
                    url: `payment/session/create`,
                    method: 'POST',
                    service: 'subscription',
                    body: body
                };
            },
            transformResponse: (response, meta, arg) => {

                var r = response;
                return r;
            },
            providesTags: ['sessionCreate']
        }),
        subscriptionDetails: builder.query({
            query: (params) => ({
                url: `payment/price/retrieve`,
                method: 'POST',
                body: {
                    "priceId": params.priceId,

                },
                service: 'subscription'
            }),
            transformResponse: (response, meta, arg) => {
                var r = response;
                return r
            },
            providesTags: ['subscriptionDetails']
        })

    }),

    overrideExisting: false
})

export const {
    useCreateSessionQuery,
    useCreateSubscriptionMutation,
    useSubscriptionDetailsQuery
} = subscriptionAPI